import { render } from "./Overlay.vue?vue&type=template&id=79c5aa95&scoped=true&ts=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./overlay.scss?vue&type=style&index=0&id=79c5aa95&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c5aa95"]])

export default __exports__